import { PalletReservationState } from "entities/PalletReservationState";
import { useCallback } from "react";
import { useBaseSummary } from "hooks/useBaseSummary";

export const usePickingListSummary = ({ orderId }) => {
	const buildFilter = useCallback(() => {
		if (!orderId) return null;
		return {
			reservation_state: PalletReservationState.RESERVED,
		};
	}, [orderId]);

	return useBaseSummary({
		endpoint: `/order/${orderId}/picking-list-reserved-summary`,
		buildFilter,
		autoFetch: false,
	});
};
